import React from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router";
import { getScoreBoardTableData } from "selectors";
import { ReduxState } from "types";

export const useScoreBoardTableData = (platformIdFromProps?: string) => {
  const { meetId, platformId } = useParams<{
    meetId: string;
    platformId: string;
  }>();

  const props = React.useMemo(() => {
    return {
      match: {
        params: {
          meetId,
          platformId: platformIdFromProps ?? platformId,
        },
      },
    };
  }, [meetId, platformId, platformIdFromProps]);

  const tableData = useSelector((state: ReduxState) =>
    getScoreBoardTableData(state, props),
  );

  return tableData;
};
